@import 'styles/mixins';
@import 'styles/variables';

.section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.previewContainer {
  width: 100%;
  max-width: 400px;
}

.preview {
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--dark-4);
  border: 1px solid var(--dark-10);
  min-height: 150px;

  // the image inside should fit as contain
  img,
  svg {
    object-fit: contain;
    max-width: 100%;
    max-height: 120px;
  }
}

.spinner {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.buttonGroup {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
}
